import memoizeOne from "memoize-one";
import { TableColumn } from "react-data-table-component";
import { UncontrolledTooltip } from "reactstrap";
import { formatToEst } from "src/common/helper";
import { Feedback } from "src/sdk/models/Ticket";

export const FeedbackColumns = memoizeOne(
    (): TableColumn<Feedback>[] => {
        return [
            {
                name: "#",
                cell: (row, index) => index + 1,
                width: "60px",
            },
            {
                name: "Feedback",
                selector: row => row.feedback,
                cell: (row: any, index: number) => {
                    const id = `feedback-${index}`;
                    return (
                        <>
                            <div
                                id={id}
                                className="feedback-preview"
                                style={{ maxHeight: '3.6em', overflow: 'hidden', lineHeight: '1.8' }}
                                dangerouslySetInnerHTML={{ __html: row.feedback }}
                            />
                            <UncontrolledTooltip
                                target={id}
                                placement="right"
                                autohide={false}
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#212529",
                                    border: "1px solid #ddd",
                                    maxWidth: 600
                                }}
                            >
                                <div
                                    style={{ maxHeight: 400, overflowY: "auto" }}
                                    dangerouslySetInnerHTML={{ __html: row.feedback }}
                                />
                            </UncontrolledTooltip>
                        </>
                    );
                },
                wrap: true,
                grow: 2,
            },
            {
                name: "Created By",
                selector: row => row.createdBy ?? "-",
                width: "150px",
            },
            {
                name: "Created At",
                selector: row => formatToEst(row.createdAt),
                width: "200px",
            }
        ];
    }
);
